<template>
  <div
    data-testid="checks-general-panel"
    class="tw-py-4 tw-px-6 tw-flex tw-flex-col tw-gap-4"
  >
    <sf-assistant-check
      v-for="checkId in generalCheckIds"
      :key="checkId"
      :check="checksById[checkId]"
      @toggle-read="sfAssistantChecksPageStore.toggleCheck(checkId)"
    />
    <div
      class="
        tw-mx-auto
        tw-my-4
        tw-font-medium
        tw-text-sm
        tw-text-sf-gray-light
        tw-text-center
      "
    >
      {{ I18n.t('assistant_check.page.checks.no_more') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import SfAssistantCheck from '@app/application/sf-assistant-checks/components/sf-assistant-check.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useSfAssistantChecksPage } from '../stores/page'

const sfAssistantChecksPageStore = useSfAssistantChecksPage()

const { generalCheckIds, checksById } = storeToRefs(sfAssistantChecksPageStore)

const I18n = useI18n()
</script>
